// 12 Zodiac Signs
export const ZODIAC_SIGNS = [
  { id: 'aries', name: '양자리', emoji: '♈', period: '3/21~4/19', color: '#ff6b6b' },
  { id: 'taurus', name: '황소자리', emoji: '♉', period: '4/20~5/20', color: '#51cf66' },
  { id: 'gemini', name: '쌍둥이자리', emoji: '♊', period: '5/21~6/21', color: '#ffd43b' },
  { id: 'cancer', name: '게자리', emoji: '♋', period: '6/22~7/22', color: '#74c0fc' },
  { id: 'leo', name: '사자자리', emoji: '♌', period: '7/23~8/22', color: '#ff922b' },
  { id: 'virgo', name: '처녀자리', emoji: '♍', period: '8/23~9/23', color: '#b197fc' },
  { id: 'libra', name: '천칭자리', emoji: '♎', period: '9/24~10/22', color: '#faa2c1' },
  { id: 'scorpio', name: '전갈자리', emoji: '♏', period: '10/23~11/22', color: '#ff6b6b' },
  { id: 'sagittarius', name: '궁수자리', emoji: '♐', period: '11/23~12/24', color: '#845ef7' },
  { id: 'capricorn', name: '염소자리', emoji: '♑', period: '12/25~1/19', color: '#66d9e8' },
  { id: 'aquarius', name: '물병자리', emoji: '♒', period: '1/20~2/18', color: '#4dabf7' },
  { id: 'pisces', name: '물고기자리', emoji: '♓', period: '2/19~3/20', color: '#91a7ff' }
];

// 12 Chinese Zodiac Signs
export const CHINESE_SIGNS = [
  { id: 'rat', name: '쥐띠', emoji: '🐭', years: '1948, 1960, 1972, 1984, 1996, 2008, 2020', color: '#718096' },
  { id: 'ox', name: '소띠', emoji: '🐮', years: '1949, 1961, 1973, 1985, 1997, 2009, 2021', color: '#8b4513' },
  { id: 'tiger', name: '호랑이띠', emoji: '🐯', years: '1950, 1962, 1974, 1986, 1998, 2010, 2022', color: '#ff8c00' },
  { id: 'rabbit', name: '토끼띠', emoji: '🐰', years: '1951, 1963, 1975, 1987, 1999, 2011, 2023', color: '#ffc0cb' },
  { id: 'dragon', name: '용띠', emoji: '🐲', years: '1952, 1964, 1976, 1988, 2000, 2012, 2024', color: '#ff4500' },
  { id: 'snake', name: '뱀띠', emoji: '🐍', years: '1953, 1965, 1977, 1989, 2001, 2013, 2025', color: '#228b22' },
  { id: 'horse', name: '말띠', emoji: '🐴', years: '1954, 1966, 1978, 1990, 2002, 2014, 2026', color: '#8b4513' },
  { id: 'goat', name: '양띠', emoji: '🐐', years: '1955, 1967, 1979, 1991, 2003, 2015, 2027', color: '#deb887' },
  { id: 'monkey', name: '원숭이띠', emoji: '🐵', years: '1956, 1968, 1980, 1992, 2004, 2016, 2028', color: '#cd853f' },
  { id: 'rooster', name: '닭띠', emoji: '🐔', years: '1957, 1969, 1981, 1993, 2005, 2017, 2029', color: '#ff6347' },
  { id: 'dog', name: '개띠', emoji: '🐶', years: '1958, 1970, 1982, 1994, 2006, 2018, 2030', color: '#d2691e' },
  { id: 'pig', name: '돼지띠', emoji: '🐷', years: '1959, 1971, 1983, 1995, 2007, 2019, 2031', color: '#ffb6c1' }
];

// 22 Tarot Major Arcana
export const TAROT_CARDS = [
  { id: 0, name: 'The Fool', kr: '바보', emoji: '🃏', color: '#ffd43b' },
  { id: 1, name: 'The Magician', kr: '마법사', emoji: '🎩', color: '#845ef7' },
  { id: 2, name: 'The High Priestess', kr: '여교황', emoji: '👸', color: '#91a7ff' },
  { id: 3, name: 'The Empress', kr: '여황제', emoji: '👑', color: '#faa2c1' },
  { id: 4, name: 'The Emperor', kr: '황제', emoji: '🤴', color: '#ff6b6b' },
  { id: 5, name: 'The Hierophant', kr: '교황', emoji: '⛪', color: '#b197fc' },
  { id: 6, name: 'The Lovers', kr: '연인', emoji: '💑', color: '#ff6787' },
  { id: 7, name: 'The Chariot', kr: '전차', emoji: '🏇', color: '#ff922b' },
  { id: 8, name: 'Strength', kr: '힘', emoji: '💪', color: '#ff6b6b' },
  { id: 9, name: 'The Hermit', kr: '은둔자', emoji: '🧙', color: '#718096' },
  { id: 10, name: 'Wheel of Fortune', kr: '운명의 수레바퀴', emoji: '🎡', color: '#ffd43b' },
  { id: 11, name: 'Justice', kr: '정의', emoji: '⚖️', color: '#4dabf7' },
  { id: 12, name: 'The Hanged Man', kr: '매달린 사람', emoji: '🙃', color: '#91a7ff' },
  { id: 13, name: 'Death', kr: '죽음', emoji: '💀', color: '#2d3748' },
  { id: 14, name: 'Temperance', kr: '절제', emoji: '⚗️', color: '#51cf66' },
  { id: 15, name: 'The Devil', kr: '악마', emoji: '😈', color: '#c92a2a' },
  { id: 16, name: 'The Tower', kr: '탑', emoji: '🗼', color: '#fa5252' },
  { id: 17, name: 'The Star', kr: '별', emoji: '⭐', color: '#ffd43b' },
  { id: 18, name: 'The Moon', kr: '달', emoji: '🌙', color: '#b197fc' },
  { id: 19, name: 'The Sun', kr: '태양', emoji: '☀️', color: '#ff922b' },
  { id: 20, name: 'Judgement', kr: '심판', emoji: '⚡', color: '#4dabf7' },
  { id: 21, name: 'The World', kr: '세계', emoji: '🌍', color: '#51cf66' }
];

// Dream Interpretation Categories
export const DREAM_CATEGORIES = [
  { id: 'animal', name: '동물 꿈', emoji: '🐍', color: '#51cf66', description: '뱀, 돼지, 용, 호랑이 등' },
  { id: 'nature', name: '자연 꿈', emoji: '🌊', color: '#4dabf7', description: '물, 불, 산, 하늘 등' },
  { id: 'person', name: '사람 꿈', emoji: '👤', color: '#faa2c1', description: '돌아가신 분, 아기, 연인 등' },
  { id: 'object', name: '물건 꿈', emoji: '💰', color: '#ffd43b', description: '돈, 금, 음식, 보석 등' },
  { id: 'action', name: '행동 꿈', emoji: '🏃', color: '#ff922b', description: '날기, 떨어지기, 쫓기기 등' },
  { id: 'place', name: '장소 꿈', emoji: '🏠', color: '#845ef7', description: '집, 학교, 바다, 산 등' },
  { id: 'body', name: '신체 꿈', emoji: '🦷', color: '#ff6b6b', description: '이빨, 머리카락, 피 등' },
  { id: 'death', name: '죽음/사고 꿈', emoji: '💀', color: '#718096', description: '죽는 꿈, 사고 꿈 등' }
];
